import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { CountryProvider } from './hooks/useCountry';
import { initMetaPixel } from './utils/metaPixel';
import { NewHomePage } from './pages/NewHomePage';
import { TryDemoPage } from './pages/TryDemoPage';
import { ServicesPage } from './pages/ServicesPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { SystemMessageConfigPage } from './pages/SystemMessageConfigPage';
import { WhatsAppDashboardPage } from './pages/WhatsAppDashboardPage';
import { HelpGoogleSheetsPage } from './pages/HelpGoogleSheetsPage';
import { HelpShopifyPage } from './pages/HelpShopifyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { AccountSuspendedPage } from './pages/AccountSuspendedPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { PaymentFailedPage } from './pages/PaymentFailedPage';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div data-id="element-0">Loading...</div>;
  }
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" data-id="element-1" />;
}
export function App() {
  // Initialize Meta Pixel on app load
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountryProvider data-id="element-2">
      <AuthProvider data-id="element-3">
        <BrowserRouter data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<NewHomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/try-demo" element={<TryDemoPage data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
            <Route path="/blog" element={<BlogPage data-id="element-13" />} data-id="element-12" />
            <Route path="/services" element={<ServicesPage data-id="element-15" />} data-id="element-14" />
            <Route path="/how-it-works" element={<HowItWorksPage data-id="element-17" />} data-id="element-16" />
            <Route path="/login" element={<LoginPage data-id="element-19" />} data-id="element-18" />
            <Route path="/register" element={<RegisterPage data-id="element-21" />} data-id="element-20" />
            <Route path="/account-suspended" element={<AccountSuspendedPage data-id="element-23" />} data-id="element-22" />
            <Route path="/subscription" element={<ProtectedRoute data-id="element-25">
                  <SubscriptionPage data-id="element-26" />
                </ProtectedRoute>} data-id="element-24" />
            <Route path="/payment/success" element={<ProtectedRoute data-id="element-28">
                  <PaymentSuccessPage data-id="element-29" />
                </ProtectedRoute>} data-id="element-27" />
            <Route path="/payment/failed" element={<ProtectedRoute data-id="element-31">
                  <PaymentFailedPage data-id="element-32" />
                </ProtectedRoute>} data-id="element-30" />
            <Route path="/dashboard" element={<ProtectedRoute data-id="element-34">
                  <DashboardPage data-id="element-35" />
                </ProtectedRoute>} data-id="element-33" />
            <Route path="/whatsapp-dashboard" element={<ProtectedRoute data-id="element-37">
                  <WhatsAppDashboardPage data-id="element-38" />
                </ProtectedRoute>} data-id="element-36" />
            <Route path="/onboarding" element={<ProtectedRoute data-id="element-40">
                  <OnboardingPage data-id="element-41" />
                </ProtectedRoute>} data-id="element-39" />
            <Route path="/configure" element={<ProtectedRoute data-id="element-43">
                  <SystemMessageConfigPage data-id="element-44" />
                </ProtectedRoute>} data-id="element-42" />
            <Route path="/help/google-sheets-oauth" element={<HelpGoogleSheetsPage data-id="element-46" />} data-id="element-45" />
            <Route path="/help/shopify-integration" element={<HelpShopifyPage data-id="element-48" />} data-id="element-47" />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </CountryProvider>;
}